const SellerServicesUrl = {
  SellerLogin: "user/auth/login",
  SellerrRegister: "user/auth/register",
  LogOut: "user/auth/logout",
  SellerChangePassword: "user/auth/change-password",
  SellerForgetPassword: "user/auth/forget-password",
  SellerResetPassword: "user/auth/reset-password",
 // Marketing
  GetMarketingData: "user/get-markting-data",
  SendMarketingRequest: "user/send-markting-request",
  //Orders
  NewOrders : "saller/new-orders",
  MyOrders: "user/my-order",
  Orders:"saller/all-my-orders",
  //orders details
// OrderDetails: "saller/order-details",
OrderDetails: "saller/order-details",
  // notifications
  SellerNotifications: "register-device-token",
  GetSellerNotifications:"notifications",
  GetSellerReadNotification:"read-notifications",
  GetSellerCountNotification:"count-unread-notifications",
  // DeleteNotification:"delete-notifications/{id}",
  SellerDeleteNotification: "delete-notifications",
  
  //Home
    SellerHome: "user/home",
    // support
 SellerGetCharity: "user/get-charity",
  SellerGetKindSupport: "user/get-kind-support",
  SellerSendSupportRequest: "user/send-support",
  // Profile
ShowProfile: "user/show-profile",
UpdateProfile: "user/update-profile",
// store/ads
ShowAdvertisements:"user/products-my-ads",
// products
 GetProductById: "user/products/{id}",
//contractpage
GetPlans:"user/auth/saller-plan-details",
// bankaccount
SellerBank: "user/saller-add-account-details",
// financial 
SellerFinancialAccounts:"saller/financial-accounts-list"

};

export default SellerServicesUrl; 
